var map = {
	"./accounts.svg": 30259,
	"./add-file-24.svg": 68814,
	"./add-file.svg": 75659,
	"./add.svg": 12392,
	"./addMark.svg": 71203,
	"./addUserInTeam.svg": 82619,
	"./advance-settings.svg": 13875,
	"./ai-activity-dislike.svg": 94123,
	"./ai-activity-like.svg": 64375,
	"./ai-config.svg": 73516,
	"./alert-tooltip.svg": 76193,
	"./alert-triangle.svg": 40108,
	"./alert.svg": 21487,
	"./alertSprint.svg": 86239,
	"./alertSprint2.svg": 15695,
	"./align-center.svg": 30724,
	"./align-justify.svg": 19773,
	"./align-left.svg": 57808,
	"./align-right.svg": 41631,
	"./archive-epics.svg": 5762,
	"./archive.svg": 72179,
	"./arrow-go-back.svg": 38939,
	"./arrow-go-forward.svg": 28941,
	"./arrow-long.svg": 21633,
	"./arrow-to.svg": 77140,
	"./arrow-up.svg": 5648,
	"./arrow.svg": 12886,
	"./arrowBacklog.svg": 42735,
	"./arrowUpdate.svg": 30609,
	"./attach.svg": 28208,
	"./attention.svg": 34943,
	"./backlog-icon.svg": 53478,
	"./backlog-item-24.svg": 93199,
	"./backlogAge/counter-0.svg": 63251,
	"./backlogAge/counter-1.svg": 41730,
	"./backlogAge/counter-2.svg": 78449,
	"./backlogAge/counter-3.svg": 42496,
	"./backlogAge/counter-4.svg": 8383,
	"./backlogAnalytics.svg": 73388,
	"./backlogSort.svg": 7824,
	"./bar-chart.svg": 96141,
	"./bell.svg": 61244,
	"./billing-notification.svg": 21816,
	"./bold.svg": 8502,
	"./calendar-full-in-row.svg": 44484,
	"./calendar-full.svg": 7449,
	"./calendar-late.svg": 85162,
	"./calendar-unavailable.svg": 70572,
	"./calendar.svg": 93657,
	"./cards-view.svg": 87598,
	"./case.svg": 88879,
	"./chart-backlog.svg": 49459,
	"./chartSprint.svg": 65401,
	"./chat-close.svg": 97310,
	"./chat-expand.svg": 51742,
	"./chat-gpt.svg": 21957,
	"./chat-pop-in.svg": 39493,
	"./chat-pop-out.svg": 81116,
	"./chat-resize.svg": 13558,
	"./chat-sidebar-close.svg": 91313,
	"./chat-sidebar-open.svg": 22515,
	"./check-list.svg": 60498,
	"./check.svg": 97649,
	"./checkbox-checked.svg": 47252,
	"./checkbox-unchecked.svg": 1615,
	"./chevron-blue.svg": 6989,
	"./chevron-gradient.dark.svg": 93737,
	"./chevron-gradient.svg": 21477,
	"./chevron-light.svg": 20575,
	"./chevron-plan.svg": 30356,
	"./chevron-with-paddings.svg": 50976,
	"./chevron.svg": 22100,
	"./circle-parts.svg": 33286,
	"./clock-full-dark.svg": 49856,
	"./clock-full.svg": 57667,
	"./clock.svg": 9435,
	"./close.svg": 1133,
	"./close2.svg": 72005,
	"./close3-dark.svg": 98201,
	"./close3.svg": 74756,
	"./closeWithBg.dark.svg": 42890,
	"./closeWithBg.svg": 5704,
	"./code-box.svg": 3376,
	"./completed.svg": 39546,
	"./continuous-sprint.svg": 65355,
	"./continuousHaltSprint.svg": 94179,
	"./copy-link.svg": 8993,
	"./copy.svg": 45176,
	"./credit-card.svg": 36739,
	"./cycle.svg": 20031,
	"./danger.svg": 9158,
	"./demo-requests.svg": 17369,
	"./disable-user.svg": 81555,
	"./done.svg": 60311,
	"./dot-crosed.svg": 51603,
	"./dots-horizontal-bottom.svg": 30776,
	"./dots-horizontal-center.svg": 88838,
	"./double-quotes.svg": 73166,
	"./doubleCheck.svg": 34116,
	"./download.svg": 51031,
	"./edit.svg": 42463,
	"./email.svg": 36769,
	"./epic-details.svg": 53905,
	"./epic-notification.svg": 65468,
	"./epic.svg": 75804,
	"./estimation-methodology.svg": 7712,
	"./expand-btn.svg": 3568,
	"./expand-open.svg": 92656,
	"./expand-top.svg": 92577,
	"./expand.svg": 69775,
	"./expandClose.svg": 7281,
	"./external-jira-link.svg": 9192,
	"./external-link.svg": 59383,
	"./external-link2.svg": 43447,
	"./face-happy.svg": 35517,
	"./face-normally.svg": 48589,
	"./face-sadness.svg": 18274,
	"./favorite-filled-dark.svg": 66713,
	"./favorite-filled.svg": 27140,
	"./favorite-folder.svg": 19600,
	"./favorite.svg": 19995,
	"./feature-icon.svg": 56695,
	"./file-del.svg": 96549,
	"./file.svg": 46789,
	"./filter.svg": 19393,
	"./flag.svg": 76809,
	"./fold-top.svg": 40480,
	"./fold.svg": 88002,
	"./folder.svg": 41355,
	"./font-color.svg": 62878,
	"./format-clear.svg": 16170,
	"./gear.svg": 54198,
	"./gearAlert.svg": 87048,
	"./goal-complete.svg": 34302,
	"./goal-icon.svg": 50160,
	"./goals-close.svg": 51866,
	"./gradient-chevron.dark.svg": 24137,
	"./gradient-chevron.svg": 62181,
	"./gradient-slash.svg": 74735,
	"./h1.svg": 22938,
	"./h2.svg": 38025,
	"./happy-smile.svg": 92700,
	"./history-icon.svg": 83397,
	"./history-timesheet-dark.svg": 85979,
	"./history-timesheet.svg": 93658,
	"./history.svg": 80113,
	"./iconAlert.svg": 36918,
	"./idea-24.svg": 52802,
	"./idea-plus.svg": 34795,
	"./idea-vote-16.svg": 76393,
	"./idea-vote-dislike-filled.svg": 44586,
	"./idea-vote-dislike-outline.svg": 57932,
	"./idea-vote-filled.svg": 49588,
	"./idea-vote-outline.svg": 39742,
	"./idea.svg": 38514,
	"./image-not-found.svg": 43721,
	"./import.svg": 30088,
	"./imported.svg": 93571,
	"./info-tooltip.svg": 73061,
	"./info.svg": 45571,
	"./integrations.svg": 34362,
	"./italic.svg": 79683,
	"./item-analytics.svg": 23465,
	"./jira-icon.svg": 69115,
	"./jira-sync.svg": 58009,
	"./lamp.svg": 38229,
	"./layout.svg": 5417,
	"./lightbulb.svg": 63696,
	"./link-off.svg": 70039,
	"./link-on.svg": 47259,
	"./link-open.svg": 37216,
	"./link.svg": 36607,
	"./list-ordered.svg": 92643,
	"./list-unordered-v2.svg": 30725,
	"./list-unordered.svg": 12012,
	"./list.svg": 42327,
	"./llm.svg": 93716,
	"./loader.svg": 65914,
	"./lock.svg": 14490,
	"./logout.svg": 47797,
	"./loupe.svg": 10592,
	"./mail.svg": 11414,
	"./max-screen.svg": 86716,
	"./maxscreen.svg": 95867,
	"./menu-dot.svg": 56188,
	"./menu-epics-24.svg": 690,
	"./menu-player-btn-story-in-row.svg": 56458,
	"./menu-player-btn-story.svg": 88027,
	"./menu-player-btn.svg": 13579,
	"./menu-player-sprint-btn.svg": 47926,
	"./menu.svg": 76674,
	"./menu2.svg": 71740,
	"./message-question-dark.svg": 40826,
	"./message-question.svg": 46553,
	"./message-smile-dark.svg": 5128,
	"./message-smile.svg": 31387,
	"./milestoneIcon.svg": 38260,
	"./minscreen.svg": 91205,
	"./more-teams.svg": 4577,
	"./more-vertical.svg": 52071,
	"./my-teams.svg": 45148,
	"./my-work-checkbox.svg": 61125,
	"./new-tab.svg": 46397,
	"./next-in-line.svg": 34927,
	"./office.svg": 82007,
	"./open-in-new-tab.svg": 13290,
	"./openInNewTab.svg": 46157,
	"./paperplane.svg": 51311,
	"./pdf.svg": 34211,
	"./pen.svg": 80260,
	"./permission-settings.svg": 19924,
	"./photo.svg": 25949,
	"./play-button.svg": 47098,
	"./play-demo.svg": 27483,
	"./play-not-found.svg": 18154,
	"./play-timestamp.svg": 65794,
	"./play.svg": 31317,
	"./plus-16.svg": 20697,
	"./plus-circle.svg": 52632,
	"./plus.svg": 92539,
	"./postMortem.svg": 29433,
	"./product-backlog-menu-icon.svg": 5800,
	"./product-backlog.svg": 1470,
	"./project-24.svg": 43649,
	"./push.svg": 72507,
	"./quality-gates.svg": 16025,
	"./quote-double.svg": 86173,
	"./raceFlag.svg": 63458,
	"./refresh.svg": 45568,
	"./reply-icon-lg.svg": 42361,
	"./reply-icon.svg": 94429,
	"./resize.svg": 32327,
	"./retrospective-done.svg": 75071,
	"./retrospective.svg": 91082,
	"./review-dark.svg": 71996,
	"./review.svg": 91751,
	"./roadmap-columns.svg": 46111,
	"./roadmap-goal-24.svg": 21006,
	"./roadmap-goal.svg": 88363,
	"./roadmap.svg": 57685,
	"./run.svg": 33434,
	"./scraper.svg": 61115,
	"./scrumHaltSprint.svg": 96418,
	"./separator.svg": 30360,
	"./settings.svg": 29340,
	"./severityLevel.svg": 94860,
	"./share.svg": 96820,
	"./skip-back-after.svg": 11260,
	"./skip-back-before.svg": 37526,
	"./smile.svg": 36553,
	"./sorting.svg": 74177,
	"./spinner-gradient-dark.svg": 2684,
	"./spinner-gradient.svg": 49959,
	"./spinner.svg": 97038,
	"./sprint-24.svg": 83486,
	"./sprint-alert.svg": 59134,
	"./sprint-info-arrow.svg": 52620,
	"./sprintAnalytics.svg": 27701,
	"./start.svg": 43489,
	"./stop.svg": 27979,
	"./story-poker-notification.svg": 61550,
	"./storyPoker.svg": 96689,
	"./strike.svg": 89593,
	"./success.svg": 5684,
	"./suggested.svg": 19336,
	"./summaries-dark.svg": 37150,
	"./summaries.svg": 98645,
	"./switch.svg": 29175,
	"./sync-setting.svg": 61293,
	"./t-short.svg": 47296,
	"./table.svg": 60297,
	"./table2.svg": 29881,
	"./tag.svg": 96469,
	"./task-breakdown.svg": 88126,
	"./task-check-list.svg": 48324,
	"./task-icon.svg": 12082,
	"./team-add.svg": 19854,
	"./team-noAvatar.svg": 34191,
	"./team-type-development.svg": 42989,
	"./team-type-devops.svg": 80929,
	"./team-type-marketing.svg": 86390,
	"./team-type-ui_ux.svg": 95488,
	"./team-unassigned.svg": 10928,
	"./team.svg": 60464,
	"./teams-multiproject.svg": 88638,
	"./teams.svg": 3059,
	"./text-wrap.svg": 39511,
	"./theme.svg": 87394,
	"./time-dark.svg": 92853,
	"./time.svg": 56712,
	"./timesheets.svg": 29992,
	"./todo-icon.svg": 31351,
	"./todo-review.svg": 63280,
	"./trash.svg": 7147,
	"./triangle_left.svg": 35181,
	"./triangle_right.svg": 67184,
	"./underline.svg": 30377,
	"./unfold.svg": 84927,
	"./unlink.svg": 82042,
	"./upload-image-dark.svg": 80681,
	"./upload-image.svg": 5972,
	"./upload.svg": 58680,
	"./upload2.svg": 28634,
	"./user-add.svg": 35440,
	"./user.svg": 82925,
	"./users.svg": 58725,
	"./usersPage.svg": 69308,
	"./warningIcon.svg": 510,
	"./waterline.dark.svg": 42604,
	"./waterline.svg": 47258,
	"./x-circle.svg": 2342,
	"./x-circleRed.svg": 21283,
	"./xls.svg": 18334,
	"./zero-sprint.svg": 90882,
	"./zoom-in.svg": 61486,
	"./zoom-out.svg": 63497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91262;